import { render, staticRenderFns } from "./text-change-analysis.vue?vue&type=template&id=1f00521c&scoped=true"
import script from "./text-change-analysis.ts?vue&type=script&lang=ts&external"
export * from "./text-change-analysis.ts?vue&type=script&lang=ts&external"
import style0 from "./text-change-analysis.less?vue&type=style&index=0&id=1f00521c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00521c",
  null
  
)

export default component.exports